
export const RefreshForValuesEnum = Object.freeze({
    inspectionStart: 'inspectionStart',
    inspectionAcceptOrReject: 'inspectionAcceptOrReject',
    pageLogInfo:'updated',
    projectRelationship:'projectRelationshipUpdated',
    cirUpdate:'cirUpdate',
});
